import { render, staticRenderFns } from "./reisen-metadata-card-releaseinformationen.vue?vue&type=template&id=71984fd2&scoped=true"
import script from "./reisen-metadata-card-releaseinformationen.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-card-releaseinformationen.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata-card-releaseinformationen.vue?vue&type=style&index=0&id=71984fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71984fd2",
  null
  
)

export default component.exports